import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class SanitaerleitungenJahr extends AbstractRequirementMapper {
  protected frontendKey = 'sanierungen.sanitaerleitungenJahr';

  public getValues(): number[] {
    return super.getValues().map((v) => Number.parseInt(<string>v, 10));
  }
}
